export default __webpack_public_path__ + "static/unicornmetalics-logo-c01d0f95cfb955dc449ce7deec414697.png";